import { DocumentReviewScreen } from '@/modules/onboarding/identity/document-review';
import React from 'react';

export default function DocumentReview() {
    return <DocumentReviewScreen />;
}
